<template>
    <section class="select-doc-dialog">
        <el-dialog :visible.sync="dialogVisible" width="70%" center top='7vh'>
            <p slot="title" style="margin:0;">{{title}}</p>
            <div class="search-row">
                <el-button type="primary" plain size="medium" style="float:left;">
                    <i class="iconfont icon-refresh"></i>
                    刷新
                </el-button>
                <el-input placeholder="请输入内容" v-model="searchValue" class="input-with-select" @keyup.enter='getData'>
                    <el-select class='search-select' v-model="searchKey" slot="prepend" placeholder="请选择">
                        <el-option value="realName" label="姓名"></el-option>
                        <el-option value="phone" label="电话"></el-option>
                        <el-option value="HospitalName" label="所属医院"></el-option>
                    </el-select>
                    <el-button slot="append" icon="el-icon-search" @click="getData"></el-button>
                </el-input>
            </div>
            <el-table :data="tableData" class="el-table" top='10vh' style="width: 100%" border max-height="500" @row-click='rowClickHandle'>
                <el-table-column label="选择" min-width="10%" align="center">
                    <template slot-scope="scope">
                        <el-radio v-model="choiceDoctor" :label="scope.row">{{blank}}</el-radio>
                    </template>
                </el-table-column>
                <el-table-column prop="realName" label="姓名" min-width="20%" align="center">
                </el-table-column>
                <el-table-column prop="phone" label="电话" min-width="20%" align="center">
                </el-table-column>
                <el-table-column prop="hospitalName" label="所属医院" min-width="50%" align="center">
                </el-table-column>
            </el-table>
            <div class="pagination-wrap">
                <el-pagination class='el-pagination' @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[20, 50]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalCount">
                </el-pagination>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitHandle">确 定</el-button>
            </span>
        </el-dialog>
    </section>
</template>

<script scoped>
import selectReq from "@/api/selectSource";
export default {
  name: "selectDoctor",
  data() {
    return {
      title: "",
      blank: "",
      choiceDoctor: "",
      dialogVisible: false,
      searchKey: "realName",
      searchValue: "",
      pageSize: 20,
      currentPage: 1,
      totalCount: 0,
      tableData: []
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    open(title) {
      this.dialogVisible = true;
      this.title = title;
    },
    close() {
      console.log("close");
      this.dialogVisible = false;
    },
    submitHandle() {
        this.$emit('select-submit', this.choiceDoctor)
        this.dialogVisible = false;
    },
    rowClickHandle(row) {
      console.log("rowClickHandle ", row);
      this.choiceDoctor = row;
    },
    getData() {
      var params = {
        page: this.currentPage,
        pageSize: this.pageSize,
        searchKey: this.searchKey,
        searchValue: this.searchValue
      };
      selectReq.selectDoctor(params).then(res => {
        if (res.Success) {
          this.tableData = res.Data.dataList;
          this.currentPage = res.Data.currentPage;
          this.totalCount = res.Data.totalCount;
          this.pageSize = res.Data.pageSize;
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getData();
    }
  }
};
</script>

<style type="text/less" lang="less" scoped>
.select-doc-dialog {
  .el-dialog__wrapper {
    background-color: rgba(0, 0, 0, 0.1);
  }
  .pagination-wrap {
    margin-top: 10px;
  }
  .el-pagination {
    float: right;
  }
  .dialog-footer {
    margin-top: 40px;
  }
}
.search-row {
  margin-bottom: 10px;
  text-align: right;
  .input-with-select {
    width: 30%;
    min-width: 350px;
  }
  .search-select {
    width: 110px;
  }
}
</style>
<style type="text/less" lang="less">
.select-doc-dialog{
    .el-dialog__body{
        padding-top:0;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/selectSource/selectDoctor.vue